import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent implements OnInit, OnDestroy {
  @Input() mensajes: string[] = ['Cargando...'];
  public mensajeActual: string = '';
  
  private mensajeIndex: number = 0;
  private intervalSub!: Subscription;

  ngOnInit(): void {
    this.mensajeActual = this.mensajes[0] || 'Cargando...';

    this.intervalSub = interval(5000).subscribe(() => {
      this.mensajeIndex = (this.mensajeIndex + 1) % this.mensajes.length;
      this.mensajeActual = this.mensajes[this.mensajeIndex];
    });
  }

  ngOnDestroy(): void {
    if (this.intervalSub) {
      this.intervalSub.unsubscribe();
    }
  }
}
